import React ,{useState}from 'react'
import NavBar from './navBar'
import Footer from './Footer'
import security1 from "../../assets/ethical1.svg"
import security2 from "../../assets/ethical2.svg"
import security3 from "../../assets/ethical3.svg"
import security4 from "../../assets/ethical4.svg"
import security5 from "../../assets/ethical5.svg"
import security6 from "../../assets/ethical6.svg"
import Hovered1 from "../../assets/hoveredEthical1.svg"
import Hovered2 from "../../assets/hoveredEthical2.svg"
import Hovered3 from "../../assets/hoveredEthical3.svg"
import Hovered4 from "../../assets/hoveredEthical4.svg"
import Hovered5 from "../../assets/hoveredEthical15.svg"
import Hovered6 from "../../assets/hoveredEthical16.svg"

const EthicalPage = () => {

     const cards = [
            {
                image: security1,
                hoveredImg: Hovered1,
                title: "Fair and Equal Opportunity",
                desc: "We believe in offering equal opportunities to all candidates, regardless of gender, ethnicity, religion, or disability. All hiring decisions are based on skills, experience, and the ability to perform the job."
            },
            {
                image: security2,
                hoveredImg: Hovered2,
                title: "Transparency in Hiring",
                desc: "We ensure that the hiring process is transparent, with clear communication to both candidates and businesses. All job requirements, compensation details, and hiring criteria are openly shared."
            },
            {
                image: security3,
                hoveredImg: Hovered3,
                title: "Respect for Privacy",
                desc: "We respect the privacy of all candidates and ensure that their personal information is handled with the confidentiality. Data is only used for hiring purposes and shared with businesses only when authorised."
            },
            {
                image: security4,
                hoveredImg: Hovered4,
                title: "Non-Discrimination Policies",
                desc: "We are committed to preventing any form of discrimination in the hiring process. Our platform actively works to eliminate bias, ensuring that candidates are evaluated based on merit and skill."
            },
            {
                image: security5,
                hoveredImg: Hovered5,
                title: "Diversity and Inclusion",
                desc: "We encourage businesses to create diverse and inclusive teams. By helping clients hire from a global talent pool, we foster varied perspectives, which leads to innovation and growth."
            },
            {
                image: security6,
                hoveredImg: Hovered6,
                title: "Ethical Use of Technology",
                desc: "We ensure that AI and other technologies used on our platform are employed ethically, maintaining human oversight and transparency in decision-making processes."
            }
        ]
    
        const [isHovered, setIsHovered] = useState(false);
  return (
    <>
    <NavBar/>
    <div className='latest-product-feature'>
                <div className='latest-product-container'>
                    <p className='latest-produt-url'>Home/Platform/Ethical principle</p>
                    <p className='latest-product-head'>
                        Ethical Principles
                    </p>
                    <p className='latest-product-desc'>Boost your job search with exclusive tools and personalized support or experience the core features of our platform at no cost!</p>
                </div>
            </div>
             <div className='latest-products-container'>
                <div className='latest-products'>
                    {
                        cards.map((card, index) => {
                            return (
                                <div
                                    key={index}
                                    className="security-card"
                                    onMouseEnter={() => setIsHovered(index)}
                                    onMouseLeave={() => setIsHovered(null)}
                                >
                                    <div 
                                    className={`security-circle ${isHovered === index ? "hovered-circle" : ""
                                            }`}
                                    >
                                        <img
                                            src={isHovered === index ? card.hoveredImg : card.image}
                                            alt={card.title}
                                        />
                                    </div>
                                    <p
                                        className={`security-card-head ${isHovered === index ? "hovered-title" : ""
                                            }`}
                                    >
                                        {card.title}
                                    </p>
                                    <p
                                        className={`security-card-desc ${isHovered === index ? "hovered-desc" : ""
                                            }`}
                                    >
                                        {card.desc}
                                    </p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
    <Footer/>
    </>
  )
}

export default EthicalPage